import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface TimeWindowsProps {
  color?: string;
  secondaryColor?: string;
  height?: string;
  width?: string;
  style?: React.CSSProperties;
}

export default function TimeWindows({
  color = RoutalPalette.primary40,
  secondaryColor = RoutalPalette.neutral02n,
  height = `18px`,
  width = `18px`,
  style = {},
}: TimeWindowsProps) {
  return (
    <SvgIcon viewBox="0 0 18 18" style={{ width, height, fill: `none`, ...style }}>
      <path
        d="M9.00042 16.7143C13.2609 16.7143 16.7147 13.2605 16.7147 9C16.7147 4.73952 13.2609 1.28572 9.00042 1.28572C4.73994 1.28572 1.28613 4.73952 1.28613 9C1.28613 13.2605 4.73994 16.7143 9.00042 16.7143Z"
        fill={color}
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 4.37143V9L12.0857 10.5429"
        stroke={secondaryColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
